// @flow
import api from 'app/core/api/api.js'
import type { StoreResourceDef } from 'app/core/types'
import type { StepsActions } from 'app/core/types/StoreResourcesCustomActions'
import { transformResults } from './utils/transformResults'
import { autocomplete } from './autocomplete.js'

export const steps: StoreResourceDef<StepsActions<>> = {
  resourceType: 'steps',
  actions: (actionsCreators) => ({
    fetchByProject: (projectId, config) => {
      const { params = {} } = config || {}
      return {
        type: 'read',
        requestKey: config?.requestKey,
        request: () => api.projects.steps({ id: projectId, ...params.queries }).then(transformResults(config)),
      }
    },
    search: autocomplete('step'),
  }),
}
